import React, { useEffect, useState } from 'react';
import { axiosInstance } from "../../utils/axios.js";
import { Activity, Calendar, FileText, Microscope, TestTube, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import './medicine.scss';

const MedicineInspectionContainer = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [inspection, setInspection] = useState([]);
 
  useEffect(() => {
    axiosInstance.get(`/medicines/1`, {
      headers: {
        'uid': props.token,
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(response => {
        setIsLoading(false)
        console.log(response.data)
        setInspection(response.data)
      });
  }, []);

  const getInspectionIcon = (menuId) => {
    switch(menuId) {
      case 47:
        return <TestTube className="inspection_type_icon blood_a" />;
      case 48:
        return <Microscope className="inspection_type_icon blood_b" />;
      default:
        return <Activity className="inspection_type_icon default" />;
    }
  };

  const getInspectionImage = (menuId) => {
    switch(menuId) {
      case 47:
        return "/images/inspection1.jpg";
      case 48:
        return "/images/inspection2.jpg";
      default:
        return "/images/inspection1.jpg";
    }
  };

  const getInspectionItems = (menuId) => {
    switch(menuId) {
      case 47:
        return "GOT(AST)/GPT(ALT)/γ-GT(γ-GPT)/中性脂肪(TG)/HDLコレステロール/ヘモグロビンA1c/LDLコレステロール/総コレステロール/アルブミン(Alb)/クレアチニン/尿酸(UA)/尿素窒素(BUN)/TP(肝機能/腎機能)";
      case 48:
        return "GOT(AST)/GPT(ALT)/γ-GT(γ-GPT)/中性脂肪(TG)/HDLコレステロール/ヘモグロビンA1c/血糖(GLU)/尿酸(UA)/尿素窒素(BUN)/総コレステロール/アルブミン(Alb)/クレアチニン/総タンパク";
      default:
        return null;
    }
  };

  if (isLoading) {
    return (
      <div>
        <div className="loader" style={{ width: '100px', height: '100px' }}></div>
        <div
          style={{
            width: '100%',
            position: 'absolute',
            bottom: '0%',
            height: '80px',
            background: '#FEFBF9',
            zIndex: '12',
          }}
        />
      </div>
    );
  }

  return (
    <div className="sunny_container">
      <div className="inspection_history_page">
        <div className="inspection_section_header">
          <Activity className="inspection_section_icon" />
          <h3 className="inspection_section_title">検査履歴</h3>
        </div>

        {inspection.length === 0 ? (
          <div className="inspection_empty_state">
            <Microscope className="empty_inspection_icon" />
            <p className="empty_inspection_title">検査履歴がありません</p>
            <p className="empty_inspection_subtitle">まずは検査を受けてみましょう</p>
          </div>
        ) : (
          <div className="inspection_list_container">
            {inspection.map((item) => (
              <div>
              <div className="inspection_result_card" key={item.id} style={{alignItems: 'center'}}>
                <div className="inspection_image_container">
                  <img
                    src={getInspectionImage(item.menu_id)}
                    alt={item.title}
                    className="inspection_result_image"
                    style={{height:'auto'}}
                  />
                  <div className="inspection_type_overlay">
                    {getInspectionIcon(item.menu_id)}
                  </div>
                </div>
                
                <div className="inspection_result_content">
                  <h4 className="inspection_result_title" style={{width:'90%'}}>{item.menu_name}</h4>
                  
                  <div className="inspection_result_details">
                    
                    <div className="inspection_detail_item" style={{width:'90%'}}>
                      <span className="detail_label" style={{width:'30%'}}>注文日:</span>
                      <span className="detail_value">{item.start_time}</span>
                    </div>
                    
                    <div className="inspection_detail_item" style={{width:'90%'}}>
                      <span className="detail_label" style={{width:'30%'}}>診療科目:</span>
                      <span className="detail_value">{item.subject}</span>
                    </div>
                    {item?.free_text && item.free_text.trim() && (
                                <div className="medicine_detail_item">
                                  <span className="detail_value">{item.free_text}</span>
                                </div>
                    )}
                  </div>
                </div>
              </div>
              <div>
                  {getInspectionItems(item.menu_id) && (
                    <div className="inspection_detail_item items">
                      <span className="detail_value items_list" style={{width:'100%'}}>
                        {getInspectionItems(item.menu_id)}
                      </span>
                    </div>
                  )}
              </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default MedicineInspectionContainer;